var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('TabView',{on:{"tab-change":_vm.handleTabChange}},[_c('TabPanel',{attrs:{"header":"จัดกลุ่มตามช่วงเวลา"}},[_c('statistic-disaster-range-time')],1),_c('TabPanel',{attrs:{"header":"เปรียบเทียบสถิติเดือนเดียวกันในแต่ละปี"}},[_c('statistic-disaster-year')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }